import React from "react";

export default function EconomicLoop()
{
  return (
    <section id="behind" className="home-behind">
      <div className="block_100  "></div>
      <div className="sc-wrap">
        <div className="img_w">
          <div className="img_ bg_contain">

          </div>
        </div>
        <header className="sc-header text-center wow fadeInUp">
          <h2>Subscribe to our newsletter
            to get all the updates and news about clics.</h2>
        </header>
        <div className="input_w">
          <div className="input_">
            <span>Enter your email here *</span>
            <div className="block_10  "></div>
            <div>
              <input type="text" />
              <button className="reset_btn  btn_dark btn_dark_lg " >Subscribe</button>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}
